import PriceForm from "./priceForm/PriceForm";
import PriceCard from "./priceCard/PriceCard";
import BookData from "./bookData/BookData";
import Confirmation from "./confirmation/Confirmation";

import useConnect from "./App.connect";


function App() {
  const {
    rentalPlaces,
    prices,
    setPrices,
    offer,
    setOffer,
    pickupPlace,
    setPickupPlace,
    booking,
    setBooking,
    rentalDates,
    setRentalDates,
  } = useConnect();

  return (
    <div className="App">
      <div className="tw-text-left">
        {!offer && (
          <PriceForm
            places={rentalPlaces}
            setPrices={setPrices}
            setOffer={setOffer}
            pickupPlace={pickupPlace}
            setPickupPlace={setPickupPlace}
            rentalDates={rentalDates}
            setRentalDates={setRentalDates}
          />
        )}

        {!offer && prices.length > 0 && (
          <div className="tw-mt-3 tw-grid md:tw-grid-cols-2 tw-gap-x-3 tw-gap-y-3">
            {prices.map((x, idx) => {
              return <PriceCard key={idx} offer={x} setSelected={setOffer} />;
            })}
          </div>
        )}

        {offer && pickupPlace && !booking && (
          <BookData
            offer={offer}
            setOffer={setOffer}
            setBooking={setBooking}
            places={rentalPlaces}
            pickupPlace={pickupPlace}
          />
        )}

        {booking && offer && <Confirmation booking={booking} offer={offer} />}
      </div>
    </div>
  );
}

export default App;
